import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { vehicleBrands } from "./vehicle-brands";

// ============================================================================
// vehicle_models — รุ่นรถ
// ============================================================================
export const vehicleModels = sqliteTable("fleet_vehicle_models", {
  id: text("id").primaryKey(), // ULID
  brandId: text("brand_id").notNull().references(() => vehicleBrands.id),
  name: text("name").notNull(),
  nameTh: text("name_th"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleModel = typeof vehicleModels.$inferSelect;
export type NewVehicleModel = typeof vehicleModels.$inferInsert;
